import { Helmet } from 'react-helmet'

import { useProject } from '../../api/project'
import { useProjectId } from '../../hooks/useProjectId'

export const Plausible = () => {
  const { data: project } = useProject(useProjectId())
  const domain = project?.plausibleDomain

  if (!domain) return false
  return (
    <Helmet>
      <script
        defer
        data-domain={domain}
        src="https://plausible.io/js/plausible.js"
      ></script>
    </Helmet>
  )
}
